var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,on:{"click":_vm.signatrueHandler}},[(!_vm.imgSrc)?_c('div',[_vm._v(" 서명란을 클릭해주세요. ")]):_c('img',{attrs:{"src":_vm.imgSrc,"alt":"signature"}})])}
var staticRenderFns = []

export { render, staticRenderFns }